import { createStyles, Slider, SliderProps } from "@mantine/core";
import React from "react";

export const useRpiSliderStyles = createStyles((theme) => {
  return {
    root: {},
    track: {
      ":before": {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.colors.text[5],
        background: theme.colors.sky[5],
      },
    },
    bar: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.text[5],
      background: theme.colors.amethyst[5],
    },
    thumb: {
      width: 24,
      height: 24,
      background: theme.colors.brand[5],
      border: "none",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    },
    dragging: {
      background: theme.colors.brand[7],
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
    },
    label: {
      background: theme.colors.calm[5],
      borderRadius: 8,
      padding: "2px 4px 2px 4px",
      ...theme.other.fontTypes.p1,
      fontWeight: theme.other.fontWeights.regular,
      color: theme.colors.brand[5],
      lineHeight: "20px",
      paddingBottom: 6,
    },
    mark: {
      display: "none",
    },
    markLabel: {
      ...theme.other.fontTypes.p3,
      fontWeight: theme.other.fontWeights.light,
      color: theme.colors.brand[5],
      marginTop: 7,
    },
  };
});

export const RpiSlider = React.forwardRef<
  HTMLDivElement,
  Omit<SliderProps, "classNames"> & React.RefAttributes<HTMLDivElement>
>((props, ref) => {
  const { classes } = useRpiSliderStyles();

  return <Slider ref={ref} size={8} labelAlwaysOn classNames={classes} {...props} />;
});
